import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// ============================================================
// Bloco 2 — Rolling refresh do JWT
// ============================================================
const REFRESH_WINDOW_MS = 2 * 60 * 60 * 1000; // 2h
let refreshing = false;

function decodeExp(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export async function tryRefreshToken() {
  if (refreshing) return;
  const token = localStorage.getItem("lab_token");
  if (!token) return;
  const expMs = decodeExp(token);
  if (!expMs) return;
  const remaining = expMs - Date.now();
  if (remaining > REFRESH_WINDOW_MS) return; // ainda longe de expirar
  if (remaining <= 0) {
    // já expirou — força logout
    localStorage.removeItem("lab_token");
    localStorage.removeItem("lab_user");
    if (!window.location.pathname.startsWith("/login")) {
      window.location.href = "/login?expired=1";
    }
    return;
  }
  refreshing = true;
  try {
    const r = await axios.post(
      `${API}/auth/refresh`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (r.data?.access_token && r.data.access_token !== token) {
      localStorage.setItem("lab_token", r.data.access_token);
    }
  } catch {
    /* silencioso — próxima request retornará 401 e o interceptor abaixo desloga */
  } finally {
    refreshing = false;
  }
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lab_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const filial = localStorage.getItem("filial_selecionada");
  if (filial) config.headers["X-Filial-ID"] = filial;
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Após resposta OK, verifica se precisa refresh (best-effort assíncrono)
    tryRefreshToken();
    return r;
  },
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("lab_token");
      localStorage.removeItem("lab_user");
      if (!window.location.pathname.startsWith("/login")
          && !window.location.pathname.startsWith("/cliente/login")
          && !window.location.pathname.startsWith("/app/definir-senha")) {
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

// Bloco 2 — checa expiração quando o usuário volta à aba
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState !== "visible") return;
    const token = localStorage.getItem("lab_token");
    if (!token) return;
    const expMs = decodeExp(token);
    if (!expMs) return;
    if (expMs <= Date.now()) {
      localStorage.removeItem("lab_token");
      localStorage.removeItem("lab_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?expired=1";
      }
    } else {
      tryRefreshToken();
    }
  });
}
